import styled from 'styled-components';
import { Tabs } from '@mui/material';

import { getColor } from '@process-advisor/process-miner/shared/theme';

export const StyledTabs = styled(Tabs)`
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid ${getColor('borderColor')};
    
    & .MuiTabs-indicator {
        width: 100%;
        background-color: ${getColor('blue')};
    }
    & .MuiTabs-root {
        height: 30px;
    }
`;

